<template>
    <div class="workshop-layout">
        <layout-header
            type="workshop"
            class="all-info"
        />
        <div class="container">
            <slot></slot>
        </div>
        <layout-footer />
    </div>
</template>

<script>
    import LayoutHeader from '@/components/user/layouts/header';
    import LayoutFooter from '@/components/user/layouts/footer';

    export default {
        name: 'workshop-layout',
        components: {
            LayoutHeader,
            LayoutFooter,
        },
    };
</script>

<style scoped lang="scss">
    .workshop-layout {
        position: relative;

        display: flex;
        flex-direction: column;

        min-height: 100vh;
    }
    .container{
        width: to_rem(1440px);
        max-width: 100%;
        margin: 0 auto;
    }
    @include mobile_or_P{
        .container{
            width: 100%;
            padding-top: 12rem;
        }
    }

    @include razr767{
        .container{
            padding-top: 18rem;
        }
    }
</style>
